import { Button, MenuItem, TextField } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

import { DataTable, MoneyText, PageHeader, PermissionGate, StatusChip, useListParams } from "../components";
import help from "./HELP.md?raw";
import { useItems, type Item } from "./useData";

const KINDS = ["manufactured", "purchased", "raw", "subcontract", "service", "phantom", "tooling", "consumable"];

export function Items() {
  const navigate = useNavigate();
  const [params, setParams] = useListParams({ ordering: "code" });
  const list = useItems(params);
  const columns: GridColDef<Item>[] = [
    { field: "code", headerName: "Item", width: 150 },
    { field: "name", headerName: "Description", flex: 1, minWidth: 220 },
    { field: "kind", headerName: "Kind", width: 120 },
    { field: "status", headerName: "Status", width: 100, renderCell: (p) => <StatusChip status={p.value as string} /> },
    { field: "current_revision", headerName: "Rev", width: 70 },
    { field: "stock_uom_code", headerName: "UoM", width: 70 },
    { field: "item_class_code", headerName: "Class", width: 90 },
    { field: "make_or_buy", headerName: "M/B", width: 70 },
    { field: "standard_cost", headerName: "Std cost", width: 110, renderCell: (p) => <MoneyText amount={p.value as string} currency="USD" /> },
    { field: "list_price", headerName: "List price", width: 110, renderCell: (p) => <MoneyText amount={p.value as string} currency="USD" /> },
    { field: "lead_time_days", headerName: "LT (d)", width: 70 },
  ];
  return (
    <>
      <PageHeader help={help} title="Items" subtitle="Parts, materials, assemblies and services" crumbs={[{ label: "Engineering" }, { label: "Items" }]}
        actions={<PermissionGate permission="engineering.item.create"><Button variant="contained" onClick={() => navigate("/app/engineering/items/new")}>New item</Button></PermissionGate>} />
      <DataTable viewKey="engineering.item.list" columns={columns} data={list.data} isLoading={list.isLoading} params={params} onParamsChange={setParams} exportPath="/api/v1/engineering/items/export/"
        onRowClick={(row) => navigate(`/app/engineering/items/${row.id}`)}
        filters={<>
          <TextField select size="small" label="Kind" value={String(params.kind ?? "")} onChange={(e) => setParams({ ...params, kind: e.target.value, page: 1 })} sx={{ width: 150 }}><MenuItem value="">All</MenuItem>{KINDS.map((k) => <MenuItem key={k} value={k}>{k}</MenuItem>)}</TextField>
          <TextField select size="small" label="Status" value={String(params.status ?? "")} onChange={(e) => setParams({ ...params, status: e.target.value, page: 1 })} sx={{ width: 130 }}><MenuItem value="">All</MenuItem>{["draft", "active", "hold", "obsolete"].map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}</TextField>
        </>} />
    </>
  );
}
